import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { fetchActiveProjects } from 'src/actions/projects';
import { fetchWorkspaceProjects } from 'src/actions/workspaceProjects';
import useProjectSystem from '../systems/useProjectSystem';

type UseAccessProjectAsManagerMutationProps = {
	projectID: number;
	workspaceID: number;
	onSuccess?: () => void;
};

const useAccessProjectAsManagerMutation = ( {
	projectID, workspaceID, onSuccess
}: UseAccessProjectAsManagerMutationProps ) => {
	const system = useProjectSystem();
	const dispatch = useDispatch();

	return useMutation(
		async () => system.accessProjectAsManager( { projectID } ),
		{
			onSuccess: () => {
				dispatch( fetchWorkspaceProjects( workspaceID ) );
				dispatch( fetchActiveProjects() );
				onSuccess?.();
			}
		}
	);
}

export default useAccessProjectAsManagerMutation;
